import { LicenseService } from '@/pages/license/types';
import startCase from 'lodash/startCase';
import { LicensePageMetaItem } from '../../../meta';

export function formatLicenseService(service: LicenseService): LicensePageMetaItem {
  return { label: startCase(service.name), content: { type: 'monospaced', content: service.ip } };
}
